<template>
  <core-Form ref="form" :model="'form'" :submit="consultaChave">
      <b-row>
          <b-col xl="2" md="2" sm="3">
              <b-form-group label="Tipo chave">
                  <b-form-select v-model="consulta.tipoChave" @change="limparConsulta" :options="$api.Arrays.TipoChavePix" required />
              </b-form-group>
          </b-col>
          <b-col xl="4" md="5" sm="3">
              <b-form-group label="Chave">
                  <b-input v-model="form.chave" @input="limparConsulta" :maxlength="77" :readonly="readonly" required />
              </b-form-group>
          </b-col>

      </b-row>

    <b-btn type="submit" v-if="!readonly" variant="primary">Consulta</b-btn>

    <br /><br />

    <span v-if="consultado===true">
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Nome Correntista">
              <b-input v-model="consulta.nomeCorrentista" disabled></b-input>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Tipo Pessoa">
              <b-form-select v-model="consulta.tipoPessoa" :options="$api.Arrays.TiposPessoa" disabled />
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Documento Federal">
              <b-input v-model="consulta.documentoFederal" disabled></b-input>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Conta">
              <b-input v-model="consulta.conta.conta" disabled></b-input>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Tipo conta">
              <b-form-select v-model="consulta.conta.tipoConta" :options="$api.Arrays.TiposConta" disabled></b-form-select>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Agência">
              <b-input v-model="consulta.conta.agencia" disabled></b-input>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Número banco">
              <b-input v-model="consulta.banco.numero" disabled></b-input>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="Descrição banco">
              <b-input v-model="consulta.banco.descricao" disabled></b-input>
              </b-form-group>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="6" xs="6">
              <b-form-group label="ISPB banco">
              <b-input v-model="consulta.banco.ispb" disabled></b-input>
              </b-form-group>
          </b-col>
        </b-row>
    </span>
  </core-Form>
</template>

<script>
export default {
  props: {
    rastreada: {
      type: Boolean,
      default: false
    },
    contaDebito: {
      type: Object
    },
    leituraQRCode: {
      type: Object
    }
  },
  watch: {
    'leituraQRCode': function (val) {
      if (val.chave) {
        this.readonly = true
        this.form.chave = val.chave
        this.consultaChave()
      } else {
        this.readonly = false
      }
    }
  },
  data () {
    return {
      form: {
        chave: null
      },
      consulta: {},
        readonly: false,
        consultado: false
    }
  },
  computed: {
    model: {
      get () {
        var obj = this.value
        return obj
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    validate () {
      let formStatus = this.$api.UI.FormValidate(this.$refs.form)

      if (!formStatus) return formStatus

      if (this.rastreada && !this.consulta.ticket) {
        this.$api.UI.ShowError('Erro', 'Obrigatório gerar ticket de consulta.')
        return false
      } else return formStatus
    },
    limparConsulta () {
        consultado = false;
    },
    consultaChave () {
      let th = this

      if (this.rastreada) {
        let dto = {
          Chave: this.form.chave,
          Agencia: this.contaDebito.agencia.numero,
          AgenciaDigito: this.contaDebito.agencia.digito,
          Conta: this.contaDebito.conta.numero,
          ContaDigito: this.contaDebito.conta.digito,
          ContaPgto: this.contaDebito.conta.contaPgto,
          TipoConta: parseInt(this.contaDebito.conta.tipoConta)
        }

        this.$api.ContaChavePix.ConsultaRastreada(dto).then((response) => {
          if (response) {
            if (response.status && response.status === 404) {
              th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
            } else if (response && response.sucesso === false) {
              th.$api.UI.ShowError('Erro', response.mensagem)
            } else if (th.$api.UI.PostAction(response)) {
              this.consultado = true;
              th.consulta = response
              th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
              th.model = Object.assign({}, response)
            }
          }
        })
      } else {
        this.$api.ContaChavePix.ConsultaChaveOnline(this.form.chave).then((response) => {
          if (response.status && response.status === 404) {
            th.$api.UI.ShowError('Erro', 'Chave não encontrada.')
          } else if (response && response.sucesso === false) {
            th.$api.UI.ShowError('Erro', response.mensagem)
          } else if (th.$api.UI.PostAction(response)) {
            this.consultado = true;
            th.consulta = response
            th.consulta.documentoFederal = th.$api.UI.Format.DocumentoFederal(response.documentoFederal)
          }
        })
      }
    }
  }
}
</script>
